import {
  Row,
  Col,
  InputGroup,
  Input,
  Button,
  ButtonGroup,
  InputGroupText,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledAlert,
} from "reactstrap";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import get from "lodash.get";
import { isEqual } from "lodash";
import firebase from "firebase/compat/app";
import { firebaseConnect, isLoaded } from "react-redux-firebase";
import IUser from "../../../types/services/IUser";
import type { ISortOption } from "../../components/sortDropdown";
import Dashboard, {
  type InactiveContactIndicators,
} from "../../components/dashboard";
import {
  bulkDeactivateInvalidContactMeans,
  getInvalidDonorsCount,
  getReindexStatus,
  enqueueReindexOperation,
  paginateDonors,
  searchDonors,
} from "../../../utils/fetch";
import type { DonorActivationFilterParam } from "../../../utils/fetch";
import withStyles from "isomorphic-style-loader/withStyles";
import { ExportType } from "../exportModal";
import s from "./styles.scss";
import DatePicker from "react-datepicker";
import datePickerS from "react-datepicker/dist/react-datepicker.css";
import classNames from "classnames";
import ReactTooltip from "react-tooltip";
import ISortByType from "../../../types/services/ISortByType";
import IMatchedDonor from "../../../types/services/IMatchedDonor";
import ISelectionUpdate from "../../../types/ISelectionUpdate";
import {
  isCurrentUserAdmin,
  isCurrentUserOnlyCollaborator,
} from "../../../utils/roleCheck";
import {
  serviceCaller,
  withModals,
  ServiceCallerProps,
  ModalProps,
  withLoginRedirect,
} from "../../composition";
import IColumnName from "../../../types/IColumnName";
import {
  applyColumnPrefs,
  TableIds,
  toggleSavedColumn,
} from "../../../utils/tablePrefs";
import * as commonActions from "../../../utils/actions/common";
import { Moment } from "moment";
import moment from "moment";
import {
  isDonorDeactivated,
  donorHasNotifications,
  getActiveMedium,
} from "../../../utils/helpers";
import { PersonalViewSparkType } from "../thankYouModal";
import PhoneRevalidationModal from "../phoneRevalidationModal";
import { donorConsoleUrl } from "../../../utils/firebaseConsoleUrls";
import { resolveDonorsFirebaseProjectId } from "../../../utils/resolveDonorsFirebaseProjectId";
import { ContactsProcessingBannerNotice } from "../fileProcessing/importProcessingNotice";

interface Props extends ServiceCallerProps, ModalProps {
  refreshDashboard: () => void;
  fileRequests?: unknown[] | null;
}

interface State {
  sortBy: ISortByType;
  searchText: string;
  searchTextUsed: string;
  selectAll: boolean;
  sortAsc: boolean;
  showExportModal: boolean;
  isLoaded: boolean;
  selectedIds: string[];
  suppressedIds: string[];
  totalResult: number;
  currentFilter: string;
  startDate: Moment;
  endDate: Moment;
  columnNames: Array<IColumnName>;
  selectedData: IUser[];
  activationFilter: DonorActivationFilterParam;
  bulkInvalidMeansBusy: boolean;
  contactsActionsMenuOpen: boolean;
  showPhoneRevalidation: boolean;
  bulkActionsDropdownOpen: boolean;
  showContactsProcessingBanner: boolean;
  donorsFirebaseProjectId?: string;
}

const sortOptions: ISortOption[] = [
  { key: "ACCOUNT", show: "Contact #", colName: "accountNumber" },
  { key: "FIRST_NAME", show: "First Name", colName: "firstName" },
  { key: "LAST_NAME", show: "Last Name", colName: "lastName" },
  { key: "EMAIL", show: "Email", colName: "email" },
  { key: "PHONE", show: "Mobile #", colName: "phoneNumber" },
];

type BulkContactActionId = "personalizedViewSpark";

const BULK_CONTACT_ACTION_ITEMS: ReadonlyArray<{
  id: BulkContactActionId;
  label: string;
}> = [{ id: "personalizedViewSpark", label: "Personalized ViewSpark" }];

class DonorsPage extends PureComponent<Props, State> {
  state = {
    sortBy: { key: "ACCOUNT", show: "Contact #", colName: "accountNumber" },
    searchText: "",
    searchTextUsed: "",
    selectAll: false,
    sortAsc: true,
    showExportModal: false,
    isLoaded: false,
    selectedIds: [],
    suppressedIds: [],
    totalResult: 0,
    currentFilter: null,
    startDate: null,
    endDate: null,
    selectedData: [],
    activationFilter: "ACTIVE_ONLY",
    bulkInvalidMeansBusy: false,
    contactsActionsMenuOpen: false,
    showPhoneRevalidation: false,
    bulkActionsDropdownOpen: false,
    showContactsProcessingBanner: false,
    columnNames: applyColumnPrefs(TableIds.contacts, [
      { key: "Contact #", isDisabled: false },
      { key: "First Name", isDisabled: false },
      { key: "Last Name", isDisabled: false },
      { key: "Company", isDisabled: false },
      { key: "Mobile #", isDisabled: false },
      { key: "Email", isDisabled: false },
      { key: "Hierarchy", isDisabled: false },
      { key: "Created On", isDisabled: false },
      { key: "Segments", isDisabled: false },
      { key: "Sms Unsubscribed From", isDisabled: true },
      { key: "Email Unsubscribed From", isDisabled: true },
    ]),
  };

  searchTimeout = null;

  filterChanged = (newOption: string) => {
    this.setState(
      {
        currentFilter: newOption,
        startDate: newOption ? this.state.startDate : null,
        endDate: newOption ? this.state.endDate : null,
        columnNames: applyColumnPrefs(
          TableIds.contacts,
          newOption
            ? [
                { key: "Contact #", isDisabled: false },
                { key: "First Name", isDisabled: false },
                { key: "Last Name", isDisabled: false },
                { key: "Company", isDisabled: false },
                { key: "Mobile #", isDisabled: false },
                { key: "Email", isDisabled: false },
                { key: "Hierarchy", isDisabled: false },
                { key: "Created On", isDisabled: false },
                { key: "Segments", isDisabled: true },
                {
                  key: "Sms Unsubscribed From",
                  isDisabled: !(newOption === "SMS"),
                },
                {
                  key: "Email Unsubscribed From",
                  isDisabled: !(newOption === "EMAIL"),
                },
              ]
            : [
                { key: "Contact #", isDisabled: false },
                { key: "First Name", isDisabled: false },
                { key: "Last Name", isDisabled: false },
                { key: "Company", isDisabled: false },
                { key: "Mobile #", isDisabled: false },
                { key: "Email", isDisabled: false },
                { key: "Hierarchy", isDisabled: false },
                { key: "Created On", isDisabled: false },
                { key: "Segments", isDisabled: false },
                { key: "Sms Unsubscribed From", isDisabled: true },
                { key: "Email Unsubscribed From", isDisabled: true },
              ]
        ),
      },
      () => {
        this.props.columnsModalChange(this.state.columnNames);
        this.props.refreshDashboard();
      }
    );
  };

  startDateChange = e => {
    let startDate = e;
    let endDate = this.state.endDate;
    if (startDate && startDate.isAfter(endDate)) {
      endDate = startDate;
    }
    this.setState({ startDate, endDate, selectAll: false }, () => {
      this.props.refreshDashboard();
    });
  };

  endDateChange = e => {
    let startDate = this.state.startDate;
    let endDate: Moment = e;
    if (startDate && startDate.isAfter(endDate)) {
      endDate = startDate;
    }
    this.setState({ startDate, endDate, selectAll: false }, () => {
      this.props.refreshDashboard();
    });
  };

  actualStartDate = () => {
    if (this.state.startDate) {
      const startDate = moment(this.state.startDate).startOf("day");
      return startDate.toDate().getTime();
    } else {
      return null;
    }
  };

  actualEndDate = () => {
    if (this.state.endDate) {
      const endDate = moment(this.state.endDate)
        .add(1, "day")
        .startOf("day");
      return endDate.toDate().getTime();
    } else {
      return null;
    }
  };

  clearStartDate = () => {
    this.setState({ startDate: null }, () => {
      this.props.refreshDashboard();
    });
  };

  clearEndDate = () => {
    this.setState({ endDate: null }, () => {
      this.props.refreshDashboard();
    });
  };

  clearDates = () => {
    this.setState(
      {
        startDate: null,
        endDate: null,
      },
      () => {
        this.props.refreshDashboard();
      }
    );
  };

  clearSearch = () => {
    this.setState({ searchText: "", searchTextUsed: "" }, () => {
      this.props.refreshDashboard();
    });
  };
  smsFilter = () => {
    this.filterChanged(this.state.currentFilter === "SMS" ? undefined : "SMS");
  };

  emailFilter = () => {
    this.filterChanged(
      this.state.currentFilter === "EMAIL" ? undefined : "EMAIL"
    );
  };

  componentDidMount() {
    if (window) {
      this.handleWindowSize();
      window.addEventListener("resize", this.handleWindowSize);
    }
    if (this.props.currentCharity) {
      if (isCurrentUserOnlyCollaborator(this.props.currentCharity)) {
        this.props.navigate("/viewsparks");
      }
    }
    this.refreshReindexBanner();
    this.refreshDonorsFirebaseProjectId();
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentCharity) {
      if (isCurrentUserOnlyCollaborator(this.props.currentCharity)) {
        this.props.navigate("/viewsparks");
      }
    }

    if (prevProps.currentCharity != this.props.currentCharity) {
      this.setState({ selectAll: false });
      this.refreshReindexBanner();
      this.refreshDonorsFirebaseProjectId();
    }

    if (!isEqual(this.props.fileRequests, prevProps.fileRequests)) {
      this.refreshReindexBanner();
    }
  }

  refreshDonorsFirebaseProjectId = async () => {
    if (!this.props.isAdminDebugUi) {
      return;
    }
    const charityId = this.props.currentCharity?.id;
    if (!charityId) {
      this.setState({ donorsFirebaseProjectId: undefined });
      return;
    }
    const projectId = await resolveDonorsFirebaseProjectId(charityId);
    this.setState({ donorsFirebaseProjectId: projectId });
  };

  refreshReindexBanner = async () => {
    const searchUrl = this.props.config?.searchServiceUrl;
    const charityId = this.props.currentCharity?.id;
    if (!searchUrl || !charityId) {
      this.setState({ showContactsProcessingBanner: false });
      return;
    }

    const status = await getReindexStatus(searchUrl, charityId);
    this.setState({ showContactsProcessingBanner: status?.donors === true });
  };

  componentWillUnmount() {
    if (window) {
      window.removeEventListener("resize", this.handleWindowSize);
    }
    if (this.searchTimeout && window) {
      window.clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
  }

  handleWindowSize = () => {
    if (window) {
      if (window.innerWidth < 768) {
        this.setState({
          columnNames: applyColumnPrefs(TableIds.contacts, [
            { key: "Contact #", isDisabled: false },
            { key: "First Name", isDisabled: true },
            { key: "Last Name", isDisabled: true },
            { key: "Company", isDisabled: true },
            { key: "Mobile #", isDisabled: true },
            { key: "Email", isDisabled: false },
            { key: "Hierarchy", isDisabled: true },
            { key: "Created On", isDisabled: true },
            { key: "Segments", isDisabled: true },
            {
              key: "Sms Unsubscribed From",
              isDisabled: !(this.state.currentFilter === "SMS"),
            },
            {
              key: "Email Unsubscribed From",
              isDisabled: !(this.state.currentFilter === "EMAIL"),
            },
          ]),
        });
      } else {
        this.setState({
          columnNames: applyColumnPrefs(TableIds.contacts, [
            { key: "Contact #", isDisabled: false },
            { key: "First Name", isDisabled: false },
            { key: "Last Name", isDisabled: false },
            { key: "Company", isDisabled: false },
            { key: "Mobile #", isDisabled: false },
            { key: "Email", isDisabled: false },
            { key: "Hierarchy", isDisabled: false },
            { key: "Created On", isDisabled: false },
            { key: "Segments", isDisabled: !!this.state.currentFilter },
            {
              key: "Sms Unsubscribed From",
              isDisabled: !(this.state.currentFilter === "SMS"),
            },
            {
              key: "Email Unsubscribed From",
              isDisabled: !(this.state.currentFilter === "EMAIL"),
            },
          ]),
        });
      }
    }
  };

  getResponse = (currentPage, pageSize) => {
    return !this.state.searchTextUsed
      ? paginateDonors(
          this.props.config.searchServiceUrl,
          this.props.currentCharity.id,
          currentPage,
          pageSize,
          this.state.sortBy.key,
          this.state.sortAsc,
          this.props.serviceAccessToken,
          this.state.currentFilter,
          this.actualStartDate(),
          this.actualEndDate(),
          false,
          this.state.activationFilter
        )
      : searchDonors(
          this.props.config.searchServiceUrl,
          this.props.currentCharity.id,
          pageSize,
          currentPage,
          this.state.searchTextUsed,
          this.props.serviceAccessToken,
          this.state.sortBy.key,
          this.state.sortAsc,
          this.state.currentFilter,
          this.actualStartDate(),
          this.actualEndDate(),
          true,
          false,
          this.state.activationFilter
        );
  };

  selectAllCheck = e => {
    this.setState({
      selectAll: e.target.checked,
      selectedIds: [],
      suppressedIds: [],
      selectedData: [],
    });
  };

  searchTextChange = e => {
    const newText: string = e.target.value;
    if (!newText || newText.length >= 3 || newText.length == 0) {
      if (this.searchTimeout && window) {
        window.clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }
      this.setState({
        searchText: newText,
        searchTextUsed: newText,
        selectAll: false,
      });
    } else {
      if (window) {
        if (this.searchTimeout) {
          window.clearTimeout(this.searchTimeout);
        }
        this.setState({
          searchText: newText,
        });
        this.searchTimeout = window.setTimeout(() => {
          this.setState({
            searchTextUsed: newText,
            selectAll: false,
          });
        }, 1500);
      }
    }
  };

  handleColumnHeaderSort = (accessor: string) => {
    const option = sortOptions.find(o => o.colName === accessor);
    if (!option) {
      return;
    }
    this.setState(
      prev => {
        const same = prev.sortBy.colName === option.colName;
        return {
          sortBy: option,
          sortAsc: same ? !prev.sortAsc : false,
        };
      },
      () => this.props.refreshDashboard()
    );
  };

  activationFilterChanged = (value: DonorActivationFilterParam) => {
    if (value === this.state.activationFilter) {
      return;
    }
    this.setState({ activationFilter: value, selectAll: false }, () => {
      this.props.refreshDashboard();
    });
  };

  toggleContactsActionsMenu = () => {
    this.setState(s => ({
      contactsActionsMenuOpen: !s.contactsActionsMenuOpen,
    }));
  };

  closeContactsActionsMenuThen = (
    action: () => void | Promise<void>
  ) => {
    this.setState({ contactsActionsMenuOpen: false }, () => {
      void Promise.resolve(action());
    });
  };

  execDonorReindex = async () => {
    const searchUrl = this.props.config?.searchServiceUrl;
    const charityId = this.props.currentCharity?.id;
    if (!searchUrl || !charityId) {
      return;
    }
    const confirmed = window.confirm(
      "Queue a full donor reindex for this charity?"
    );
    if (!confirmed) {
      return;
    }
    try {
      await enqueueReindexOperation(searchUrl, charityId, "donors");
      window.alert("Donor reindex queued.");
      this.refreshReindexBanner();
    } catch (err) {
      window.alert(err && err.message ? err.message : "Request failed.");
    }
  };

  bulkDeactivateInvalidMeansAction = async () => {
    const adminUrl = this.props.config && this.props.config.adminServiceUrl;
    if (!adminUrl || !this.props.currentCharity || !this.props.serviceAccessToken) {
      return;
    }
    const confirmed = window.confirm(
      "This will scan your contacts looking for all those that have no valid contact methods and deactivate them.\n\nDo you wish to continue?"
    );
    if (!confirmed) {
      return;
    }
    this.setState({ bulkInvalidMeansBusy: true });
    try {
      const res = await bulkDeactivateInvalidContactMeans(
        adminUrl,
        this.props.currentCharity.id,
        this.props.serviceAccessToken
      );
      window.alert(res.message);
      this.props.refreshDashboard();
    } catch (err) {
      window.alert(err && err.message ? err.message : "Request failed.");
    } finally {
      this.setState({ bulkInvalidMeansBusy: false });
    }
  };

  showExportModal(
    exportType: ExportType,
    exportIdsArray?: [string],
    exportTotalIds?: string,
    exportFromDate?: number,
    exportToDate?: number,
    ignoreSelected?: boolean
  ) {
    this.props.toggleExportModal(
      exportType,
      exportIdsArray,
      exportTotalIds,
      exportFromDate,
      exportToDate,
      ignoreSelected
    );
  }

  async getIdsToExport() {
    let totalIds = null;
    if (this.state.selectAll) {
      if (this.state.searchTextUsed) {
        let res = await searchDonors(
          this.props.config.searchServiceUrl,
          this.props.currentCharity.id,
          10000,
          0,
          this.state.searchTextUsed,
          this.props.serviceAccessToken,
          this.state.sortBy.key,
          this.state.sortAsc,
          this.state.currentFilter,
          this.actualStartDate(),
          this.actualEndDate(),
          true,
          false,
          this.state.activationFilter
        );
        totalIds = res.result.map(user => user.id);
        if (this.state.suppressedIds.length > 0) {
          totalIds = totalIds.filter(
            id => !this.state.suppressedIds.includes(id)
          );
        }
        return totalIds;
      } else {
        return this.state.suppressedIds;
      }
    }
    return this.state.selectedIds;
  }

  execExport = async () => {
    const exportAmount = this.state.selectAll
      ? this.state.totalResult - this.state.suppressedIds.length
      : this.state.selectedIds.length === 0
      ? this.state.totalResult
      : this.state.selectedIds.length;
    let idsToExport = await this.getIdsToExport();
    this.props.toggleExportModal(
      ExportType.donors,
      idsToExport,
      exportAmount.toString(),
      this.actualStartDate(),
      this.actualEndDate(),
      this.state.selectAll && !this.state.searchTextUsed,
      null,
      null,
      null,
      null,
      null,
      this.state.currentFilter
    );
  };

  execExportInvalids = async () => {
    let total = await getInvalidDonorsCount(
      this.props.config.searchServiceUrl,
      this.props.currentCharity.id,
      this.props.serviceAccessToken
    );
    this.props.toggleExportModal(
      ExportType.invalidDonors,
      null,
      total.targetCount.toString(),
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null
    );
  };

  newDonor = () => {
    this.props.navigate("/contacts/new");
  };

  showDonorDetail = (donor: IMatchedDonor) => {
    this.props.navigate(`/contacts/${donor.id}`);
  };

  donorDeactivated = (donor: IMatchedDonor): boolean => {
    return donor.deactivated == undefined ? false : donor.deactivated;
  };

  goToNewViewSpark = (donors: Array<IUser>) => {
    const thanksDonorSegments = [],
      donorSet = new Set<string>();

    donors.forEach((donor: IUser) => {
      if (
        donorSet.has(donor.id) ||
        !donorHasNotifications(donor) ||
        isDonorDeactivated(donor)
      )
        return;
      donorSet.add(donor.id);
      thanksDonorSegments.push({
        label: donor.name + " - " + getActiveMedium(donor),
        value: "D" + donor.id,
      });
    });
    this.props.navigate("/viewsparks/new", {
      state: {
        thanksDonorSegments: thanksDonorSegments,
        thanksDonationIds: [],
      },
    });
  };

  showGroupThankYouModal = async (): Promise<void> => {
    let donors: IUser[];
    try {
      donors = await this.resolveDonorsForBulkThankYou();
    } catch {
      window.alert(
        "Could not load the selected contacts. Try again or narrow your selection."
      );
      return;
    }
    const thankYouInfos = donors.map(donor => ({ donor }));
    this.props.toggleThankYouModal(
      thankYouInfos,
      PersonalViewSparkType.Personalized,
      () => this.goToNewViewSpark(donors),
      null,
      false
    );
  };

  showThankYouModal = (donor: IMatchedDonor) => {
    if (this.donorDeactivated(donor)) return null;
    const thankYouInfo = { donor };
    this.props.toggleThankYouModal(
      [thankYouInfo],
      PersonalViewSparkType.Personalized,
      () => this.goToNewViewSpark([donor]),
      null,
      false
    );
  };

  inactiveContactIndicators: InactiveContactIndicators = {
    isInactive: (donor: IMatchedDonor) =>
      donor.deactivated === true,
    badgeReplacementColumnAccessor: "segments",
    italicColumnAccessors: ["firstName", "lastName"],
  };

  effectiveBulkSelectionCount = (): number => {
    if (this.state.selectAll) {
      return Math.max(
        0,
        this.state.totalResult - this.state.suppressedIds.length
      );
    }
    return this.state.selectedData.length;
  };

  openDonorFirebase = (donor: IMatchedDonor) => {
    if (!donor?.id || this.donorDeactivated(donor)) {
      return;
    }
    const pid =
      this.state.donorsFirebaseProjectId ||
      (firebase.app().options as { projectId?: string }).projectId;
    if (!pid) {
      return;
    }
    window.open(
      donorConsoleUrl(pid, this.props.currentCharity.id, donor.id),
      "_blank",
      "noopener,noreferrer"
    );
  };

  selectionUpdate = (update: ISelectionUpdate) => {
    this.setState(prev => {
      const totalResult = update.totalAmount;
      const suppressedIds = update.suppressedIds;
      const selectedData = update.selectedData;
      const effective = prev.selectAll
        ? Math.max(0, totalResult - suppressedIds.length)
        : selectedData.length;
      return {
        totalResult,
        selectedIds: update.selectedIds,
        suppressedIds,
        selectedData,
        ...(effective === 0 ? { bulkActionsDropdownOpen: false } : {}),
      };
    });
  };

  toggleBulkActionsDropdown = (): void => {
    if (this.effectiveBulkSelectionCount() === 0) {
      return;
    }
    this.setState(prev => ({
      bulkActionsDropdownOpen: !prev.bulkActionsDropdownOpen,
    }));
  };

  resolveDonorsForBulkThankYou = async (): Promise<IUser[]> => {
    const {
      selectAll,
      selectedData,
      suppressedIds,
      searchTextUsed,
      sortBy,
      sortAsc,
      currentFilter,
      activationFilter,
      totalResult,
    } = this.state;

    if (!selectAll || selectedData.length > 0) {
      return selectedData;
    }

    const searchUrl = this.props.config.searchServiceUrl;
    const charityId = this.props.currentCharity.id;
    const token = this.props.serviceAccessToken;
    const suppressed = new Set(suppressedIds);

    if (searchTextUsed) {
      const res = await searchDonors(
        searchUrl,
        charityId,
        10000,
        0,
        searchTextUsed,
        token,
        sortBy.key,
        sortAsc,
        currentFilter,
        this.actualStartDate(),
        this.actualEndDate(),
        true,
        false,
        activationFilter
      );
      return res.result.filter(u => !suppressed.has(u.id));
    }

    const pageSize = Math.min(10000, Math.max(totalResult, 1));
    const res = await paginateDonors(
      searchUrl,
      charityId,
      0,
      pageSize,
      sortBy.key,
      sortAsc,
      token,
      currentFilter,
      this.actualStartDate(),
      this.actualEndDate(),
      false,
      activationFilter
    );
    return res.result.filter(u => !suppressed.has(u.id));
  };

  handleBulkContactAction = (actionId: BulkContactActionId): void => {
    this.setState({ bulkActionsDropdownOpen: false });
    switch (actionId) {
      case "personalizedViewSpark":
        void this.showGroupThankYouModal();
        break;
      default:
        break;
    }
  };

  columnData = [
    "accountNumber",
    "firstName",
    "lastName",
    "company",
    "phoneNumber",
    "email",
    "deliveryChannel",
    "createdOnPretty",
    "segments",
    "smsUnsubscribedPretty",
    "emailUnsubscribedPretty",
  ];

  getExtraColumns = () => {
    const base = [
      {
        id: "users",
        hasTooltip: true,
        tooltipText: "Contact Details",
        type: "icon" as const,
        width: 45,
        faIcon: "fa-user-circle",
        className: "customColUsersIcon",
        showFunctions: this.showDonorDetail,
      },
      {
        id: "personal-viewspark-donor",
        hasTooltip: true,
        tooltipText: "Create a Personalized Viewspark",
        type: "icon" as const,
        width: 45,
        faIcon: "fa-envelope",
        className: "customColUsersIcon",
        showFunctions: this.showThankYouModal,
        hideIconWhen: this.donorDeactivated,
      },
    ];
    if (!this.props.isAdminDebugUi) {
      return base;
    }
    return [
      ...base,
      {
        id: "firebase-donor",
        hasTooltip: true,
        tooltipText: "Open in Firebase (contact)",
        type: "icon" as const,
        width: 45,
        faIcon: "fa-database",
        className: "customColUsersIcon",
        showFunctions: this.openDonorFirebase,
        isDeactivated: (donor: IMatchedDonor) => this.donorDeactivated(donor),
        deactivatedClassName: "customColUsersIconDeactivated",
      },
    ];
  };

  disableColumn = index => {
    const copy = toggleSavedColumn(
      TableIds.contacts,
      this.state.columnNames,
      index
    );
    this.setState(
      {
        columnNames: copy,
      },
      () => {
        this.props.columnsModalChange(this.state.columnNames);
      }
    );
  };

  changeColumns = () => {
    this.props.toggleColumnsModal(this.disableColumn, this.state.columnNames);
  };

  render() {
    return (
      <main className={s.main}>
        <PhoneRevalidationModal
          isOpen={this.state.showPhoneRevalidation}
          toggle={() =>
            this.setState({ showPhoneRevalidation: false }, () =>
              this.props.refreshDashboard()
            )
          }
        />
        <div className={s.container}>
          {this.state.showContactsProcessingBanner && (
            <UncontrolledAlert color="info" className={s.processingBanner}>
              <ContactsProcessingBannerNotice linkClassName={s.processingBannerLink} />
            </UncontrolledAlert>
          )}
          <Row className={s.marginBot}>
            <Col xs={12} className={classNames(s.colMargin, s.noPadding)}>
              <div className={s.contactsToolbarFlex}>
                <div className={s.toolbarLeft}>
                  <div
                    className={s.inlineDots}
                    onClick={this.changeColumns}
                    onKeyDown={e => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        this.changeColumns();
                      }
                    }}
                    role="button"
                    tabIndex={0}
                    data-tip
                    data-for="donors-column-mgmt"
                    aria-label="Column management"
                  >
                    <i className={"fa fa-columns " + s.dotIcon}>&nbsp;</i>
                  </div>
                  <ReactTooltip
                    id="donors-column-mgmt"
                    effect="solid"
                    place="top"
                  >
                    Column management
                  </ReactTooltip>
                  <ButtonGroup className={s.activationFilterGroup}>
                  <Button
                    className={classNames(
                      s.activationFilterButton,
                      this.state.activationFilter === "ALL"
                        ? s.activationFilterButtonActive
                        : undefined
                    )}
                    active={this.state.activationFilter === "ALL"}
                    onClick={() => this.activationFilterChanged("ALL")}
                    color={"none"}
                  >
                    All
                  </Button>
                  <Button
                    className={classNames(
                      s.activationFilterButton,
                      this.state.activationFilter === "ACTIVE_ONLY"
                        ? s.activationFilterButtonActive
                        : undefined
                    )}
                    active={this.state.activationFilter === "ACTIVE_ONLY"}
                    onClick={() => this.activationFilterChanged("ACTIVE_ONLY")}
                    color={"none"}
                  >
                    Active
                  </Button>
                  <Button
                    className={classNames(
                      s.activationFilterButton,
                      this.state.activationFilter === "DEACTIVATED_ONLY"
                        ? s.activationFilterButtonActive
                        : undefined
                    )}
                    active={
                      this.state.activationFilter === "DEACTIVATED_ONLY"
                    }
                    onClick={() =>
                      this.activationFilterChanged("DEACTIVATED_ONLY")
                    }
                    color={"none"}
                  >
                    Deactivated
                  </Button>
                </ButtonGroup>
                </div>
                <div className={s.toolbarSearchGrow}>
                  <InputGroup className={s.searchInputFullWidth}>
                    <InputGroupText className={s.inputGroup}>
                      <i className={classNames("fa fa-search", s.searchIcon)}>
                        &nbsp;
                      </i>
                    </InputGroupText>
                    <Input
                      id="searchText"
                      placeholder={"Search"}
                      value={this.state.searchText}
                      onChange={this.searchTextChange}
                      className={s.text}
                    />
                    <InputGroupText
                      className={s.inputGroupRight}
                    >
                      <i
                        className={classNames("fa fa-times", s.closeIcon)}
                        onClick={this.clearSearch}
                      >
                        &nbsp;
                      </i>
                    </InputGroupText>
                  </InputGroup>
                </div>
                <div className={s.toolbarActions}>
                  {isCurrentUserAdmin(this.props.currentCharity) && (
                    <Button
                      id={"NewDonorButton"}
                      color="primary"
                      className={s.newContactPrimaryButton}
                      onClick={this.newDonor}
                    >
                      New Contact
                    </Button>
                  )}
                  <Dropdown
                    isOpen={this.state.contactsActionsMenuOpen}
                    toggle={this.toggleContactsActionsMenu}
                  >
                    <DropdownToggle
                      color="link"
                      className={s.contactsToolbarExtras}
                      aria-label="More actions"
                    >
                      <i className="fa fa-ellipsis-v" />
                    </DropdownToggle>
                    <DropdownMenu
                      right
                      className={s.contactsDropdownMenu}
                      modifiers={[
                        {
                          name: "offset",
                          options: {
                            offset: [0, 8],
                          },
                        },
                      ]}
                    >
                      <DropdownItem
                        onClick={() =>
                          this.closeContactsActionsMenuThen(() =>
                            this.execExport()
                          )
                        }
                      >
                        Export
                      </DropdownItem>
                      <DropdownItem
                        onClick={() =>
                          this.closeContactsActionsMenuThen(() =>
                            this.execExportInvalids()
                          )
                        }
                      >
                        Export Invalids
                      </DropdownItem>
                      {isCurrentUserAdmin(this.props.currentCharity) && (
                        <DropdownItem
                          onClick={() =>
                            this.closeContactsActionsMenuThen(() =>
                              this.bulkDeactivateInvalidMeansAction()
                            )
                          }
                          disabled={this.state.bulkInvalidMeansBusy}
                        >
                          Deactivate Invalids
                        </DropdownItem>
                      )}
                      {this.props.isSuperadmin && (
                        <DropdownItem
                          onClick={() =>
                            this.closeContactsActionsMenuThen(() =>
                              this.setState({ showPhoneRevalidation: true })
                            )
                          }
                        >
                          Revalidate Invalid Phones
                        </DropdownItem>
                      )}
                      {this.props.isAdminDebugUi && (
                        <DropdownItem
                          onClick={() =>
                            this.closeContactsActionsMenuThen(() =>
                              this.execDonorReindex()
                            )
                          }
                        >
                          Reindex donors
                        </DropdownItem>
                      )}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
            </Col>
          </Row>
          <Row className={s.marginBot}>
            <Col
              xs={12}
              className={classNames(
                s.optOutRowLeft,
                s.colMargin,
                s.noPadding
              )}
            >
              <div className={s.optOutRowFlex}>
                <div className={s.optOutRowMain}>
                  <div className={s.optOutControls}>
                    <div
                      className={s.optOutButtonGroupTooltipWrap}
                      data-tip
                      data-for="opt-out-date-filter"
                    >
                      <ButtonGroup
                        className={
                          this.effectiveBulkSelectionCount() > 1
                            ? s.optOutButtonGroup
                            : s.buttonGroup
                        }
                      >
                        <Button
                          id={"OptOutSms"}
                          className={
                            this.state.currentFilter === "SMS"
                              ? s.button_active
                              : s.button
                          }
                          active={this.state.currentFilter === "SMS"}
                          onClick={this.smsFilter}
                          color={"none"}
                        >
                          Opt Out MMS
                        </Button>
                        <Button
                          id={"OptOutEmail"}
                          className={
                            this.state.currentFilter === "EMAIL"
                              ? s.button_active
                              : s.button
                          }
                          active={this.state.currentFilter === "EMAIL"}
                          onClick={this.emailFilter}
                          color={"none"}
                        >
                          Opt Out Email
                        </Button>
                      </ButtonGroup>
                    </div>
                    <ReactTooltip
                      id="opt-out-date-filter"
                      effect="solid"
                      place="bottom"
                    >
                      Filter contacts by unsubscribe date
                    </ReactTooltip>
                  </div>
                  {this.state.currentFilter && (
                    <div
                      className={classNames(
                        s.optOutDatesInline,
                        s.hiddenXs
                      )}
                    >
                    <div className={s.noFlex}>
                      <div className={s.inputGroup}>
                        <i
                          className={classNames(
                            "fa fa-calendar",
                            s.calendarIcon
                          )}
                        >
                          &nbsp;
                        </i>
                      </div>
                      <div className={s.pickerWidth}>
                        <DatePicker
                          id="from"
                          selected={this.state.startDate}
                          selectsStart
                          startDate={this.state.startDate}
                          endDate={this.state.endDate}
                          onChange={this.startDateChange}
                          className={s.textDate}
                          placeholderText={"From: mm/dd/yyyy"}
                          autoComplete="off"
                        />
                      </div>
                      <div className={s.pickerWidth}>
                        <DatePicker
                          id="to"
                          selected={this.state.endDate}
                          selectsEnd
                          startDate={this.state.startDate}
                          endDate={this.state.endDate}
                          onChange={this.endDateChange}
                          className={s.textDate}
                          placeholderText={"To: mm/dd/yyyy"}
                          autoComplete="off"
                        />
                      </div>
                      <div className={s.inputGroupRight}>
                        <i
                          className={classNames("fa fa-times", s.closeIcon)}
                          onClick={this.clearDates}
                        >
                          &nbsp;
                        </i>
                      </div>
                    </div>
                  </div>
                )}
                </div>
                <div className={s.bulkActionsWrap}>
                  <div className={s.bulkActionsSizer} aria-hidden="true">
                    <div className={s.bulkActionsSizerStack}>
                      <span className={s.bulkActionsSizerToggleLine}>
                        Action...
                        <span className={s.bulkActionsSizerCaretStub} />
                      </span>
                      {BULK_CONTACT_ACTION_ITEMS.map(item => (
                        <span
                          key={item.id}
                          className={s.bulkActionsSizerMenuLine}
                        >
                          {item.label}
                        </span>
                      ))}
                    </div>
                  </div>
                  <Dropdown
                    className={s.bulkActionsDropdown}
                    isOpen={
                      this.effectiveBulkSelectionCount() > 0 &&
                      this.state.bulkActionsDropdownOpen
                    }
                    toggle={this.toggleBulkActionsDropdown}
                  >
                    <DropdownToggle
                      caret
                      disabled={this.effectiveBulkSelectionCount() === 0}
                      className={classNames(
                        s.button,
                        s.bulkActionsDropdownToggle
                      )}
                      color={"none"}
                      id="contactsBulkActionsDropdown"
                      aria-label="Contact actions"
                    >
                      Action...
                    </DropdownToggle>
                    <DropdownMenu
                      end
                      className={classNames(
                        s.contactsDropdownMenu,
                        s.bulkActionsDropdownMenu
                      )}
                    >
                      {BULK_CONTACT_ACTION_ITEMS.map(item => (
                        <DropdownItem
                          key={item.id}
                          id={`bulkAction_${item.id}`}
                          onClick={() =>
                            this.handleBulkContactAction(item.id)
                          }
                        >
                          {item.label}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
            </Col>
            {this.state.currentFilter && (
              <Col xs={12} className={s.colMargin + " " + s.hiddenMd}>
                <Row>
                  <Col xs={12} className={s.colMargin}>
                    <InputGroup className={s.noFlex}>
                      <InputGroupText
                        className={s.inputGroup}
                      >
                        <i className={"fa fa-calendar " + s.calendarIcon}>
                          &nbsp;
                        </i>
                      </InputGroupText>
                      <div className={s.pickerWidth}>
                        <DatePicker
                          id="from"
                          selected={this.state.startDate}
                          selectsStart
                          startDate={this.state.startDate}
                          endDate={this.state.endDate}
                          onChange={this.startDateChange}
                          className={s.textDate}
                          placeholderText={"From: mm/dd/yyyy"}
                          autoComplete="off"
                        />
                      </div>
                      <InputGroupText
                        className={s.inputGroupRight}
                      >
                        <i
                          className={"fa fa-times " + s.closeIcon}
                          onClick={this.clearStartDate}
                        >
                          &nbsp;
                        </i>
                      </InputGroupText>
                    </InputGroup>
                  </Col>
                  <Col xs={12} className={s.colMargin}>
                    <InputGroup className={s.noFlex}>
                      <InputGroupText
                        className={s.inputGroup}
                      >
                        <i
                          className={classNames(
                            "fa fa-calendar",
                            s.calendarIcon
                          )}
                        >
                          &nbsp;
                        </i>
                      </InputGroupText>
                      <div className={s.pickerWidth}>
                        <DatePicker
                          id="to"
                          selected={this.state.endDate}
                          selectsEnd
                          startDate={this.state.startDate}
                          endDate={this.state.endDate}
                          onChange={this.endDateChange}
                          className={s.textDate}
                          placeholderText={"To: mm/dd/yyyy"}
                          autoComplete="off"
                        />
                      </div>
                      <InputGroupText
                        className={s.inputGroupRight}
                      >
                        <i
                          className={classNames("fa fa-times", s.closeIcon)}
                          onClick={this.clearEndDate}
                        >
                          &nbsp;
                        </i>
                      </InputGroupText>
                    </InputGroup>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
          <Row>
            <Col xs={12} className={classNames(s.noPadding, s.donorsTableWrap)}>
              {this.props.serviceAccessToken && this.props.config && (
                <Dashboard
                  tableId={TableIds.contacts}
                  columnNames={this.state.columnNames}
                  columnData={this.columnData}
                  extraColumns={this.getExtraColumns()}
                  selectionUpdate={this.selectionUpdate}
                  checkCol
                  selectAllInCheckboxHeader
                  onSelectAllCheckboxChange={this.selectAllCheck}
                  suppressedIds={this.state.suppressedIds}
                  sortBy={this.state.sortBy.colName}
                  selectAll={this.state.selectAll}
                  sortAsc={this.state.sortAsc}
                  searchText={this.state.searchTextUsed}
                  filtered={!!this.state.searchTextUsed}
                  footerMessage="Donors Selected"
                  noDataText={"No Donors Found"}
                  currentCharity={this.props.currentCharity}
                  getResponse={this.getResponse}
                  inactiveContactIndicators={this.inactiveContactIndicators}
                  columnHeaderSort={{
                    sortAccessor: this.state.sortBy.colName,
                    sortAscending: this.state.sortAsc,
                    sortableAccessors: sortOptions.map(o => o.colName),
                    onSort: this.handleColumnHeaderSort,
                  }}
                />
              )}
            </Col>
          </Row>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => {
  const charityId = state.user.currentCharity?.id;
  const fileRequests =
    charityId && isLoaded(state.firebase.data[charityId]?.fileRequests)
      ? get(state.firebase, `ordered.${charityId}.fileRequests`)
      : null;

  return { fileRequests };
};

const mapDispatchToProps = dispatch => ({
  refreshDashboard: () => {
    dispatch(commonActions.refreshDashboard());
  },
});

export default serviceCaller(
  withLoginRedirect(
    withModals(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(
        firebaseConnect((_props, store) => {
          const charityId = store.getState().user.currentCharity?.id;

          if (charityId) {
            return [
              {
                path: `${charityId}/fileRequests`,
                queryParams: ["orderByChild=uploadedDateTimestamp"],
              },
            ];
          }
          return [];
        })(withStyles(s, datePickerS)(DonorsPage))
      )
    )
  )
);
